import React, { useRef, useEffect, useState } from 'react';
import { 
  Brain, BookOpen, Users, Smile, Target, Trophy, Mic, Clock,
  Star, ChevronLeft, ChevronRight, Play, CheckCircle, Heart,
  Lightbulb, MessageCircle, Eye, Zap, Award, Search,Sparkles,GraduationCap,Languages
} from 'lucide-react';
import "../../Component/parvam.css";

const Programs = () => {
  const videoRef = useRef(null);
  const videos = [
    '/assets/images/testimals_1.mp4',
    '/assets/images/testimals_2.mp4',
  ];
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const handleEnded = () => {
      const nextIndex = (currentVideoIndex + 1) % videos.length;
      setCurrentVideoIndex(nextIndex);
    };

    const handleCanPlay = () => {
      video.play().catch((err) => console.warn('Autoplay failed:', err));
    };

    video.addEventListener('ended', handleEnded);
    video.addEventListener('canplay', handleCanPlay);

    video.load(); // Trigger loading the new video source

    return () => {
      video.removeEventListener('ended', handleEnded);
      video.removeEventListener('canplay', handleCanPlay);
    };
  }, [currentVideoIndex]);

  const [activeCarousel, setActiveCarousel] = useState(0);

  const teacherImages = [
    "assets/images/Team/teacher_1.webp",
    "assets/images/Team/teacher_2.webp",
    "assets/images/Team/teacher_4.webp",
    "assets/images/Team/teacher_3.webp",
    // "assets/images/Team/teacher_5.webp"
  ];
  const teacherNames = ["Ananya", "Rajesh", "Priya", "Vikram"];
const teacherRoles = ["Lead Researcher", "Data Scientist", "Curriculum Designer", "AI Specialist"];
const teacherIcons = ["bi-mortarboard-fill", "bi-flower1", "bi-bezier2", "bi-robot"];


  const testimonials = [
    { 
      name: "Arjun K.", 
      grade: "Grade 8", 
      quote: "I now love fractions! Math became so easy with Yummy Learning.", 
      img: "assets/images/Testimonial/testimonial_1.webp" 
    },
    { 
      name: "Priya S.", 
      grade: "Grade 6", 
      quote: "Speaking English is now my superpower thanks to ESCP!", 
      img: "assets/images/Testimonial/testimonial_2.webp" 
    },
    { 
      name: "Rahul M.", 
      grade: "Grade 9", 
      quote: "Teaching others in Innoflip made me understand concepts better.", 
      img: "assets/images/Testimonial/testimonial_4.webp" 
    }
  ];

  const carouselImages = [
    { day: "Day 1", title: "Welcome Ceremony", img: "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80" },
    { day: "Day 2", title: "Icebreaker Activities", img: "https://images.unsplash.com/photo-1541178735493-479c1a27ed24?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1471&q=80" },
    { day: "Day 3", title: "Culture Workshop", img: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1471&q=80" }
  ];

  return (
    <div className="programs-page">
      {/* Hero Section */}
      <section className="Subpage_Hero">
      <div className="container">
        <div className="text-lg-start text-center" data-aos="fade-up">
          <h1>Our Programs</h1>
          <p>
          This page must stand out with icons, infographics, student videos, and success stories. 

          </p>
        </div>
      </div>
    </section>
      

      {/* Parvam Program */}
      <section className="parvam-section bg-white ">
      <div className="parvam-container">
        <div className="header text-center">
          <div className="header-icon">
            <Brain size={28} />
          </div>
          <h3 className="h2  header-title">Parvam Program</h3>
          <p className="lead text-muted max-w-800 mx-auto">
            A powerful start to your day with meditation, affirmations, visualization,</p>
        </div>
        <div className="content-row">
          {/* Text and Features Column */}
          <div className="content-col card" data-aos="zoom-in-right" data-aos-delay="300" data-aos-duration="1000 ">
            <p className="description">
              A powerful start to your day with meditation, affirmations, visualization, reading, memory games, and puzzles.
            </p>
        <div className="parvam-feature-grid shadow-none">
          {[
            { icon: <Eye size={24} className="icon-primary" />, title: 'Visualization', text: 'Silva Method techniques for mental clarity' },
            { icon: <Heart size={24} className="icon-danger" />, title: 'Meditation', text: 'Daily mindfulness practice' },
            { icon: <BookOpen size={24} className="icon-warning" />, title: 'Reading', text: 'Subconscious Mind development' },
            { icon: <Lightbulb size={24} className="icon-info" />, title: 'Memory Games', text: 'Cognitive enhancement exercises' },
          ].map((f, i) => (
            <div className="parvam-feature-col card" key={i} data-aos="fade-right" data-aos-delay={`${i * 100}`} data-aos-duration="800">
              <div className="parvam-feature-card">
                <div className="parvam-feature-icon">{f.icon}</div>
                <h6 className="parvam-feature-title">{f.title}</h6>
                <p className="parvam-feature-text">{f.text}</p>
              </div>
            </div>
          ))}
        </div>

            <div className="daily-structure mb-0">
              <h6 className="daily-title">Daily Structure</h6>
              <ul className="daily-list">
                {[
                  { time: '6:30 AM', text: 'Meditation & Affirmations', color: 'dot-primary' },
                  { time: '7:00 AM', text: 'Visualization Exercises', color: 'dot-warning' },
                  { time: '7:30 AM', text: 'Reading & Memory Games', color: 'dot-info' },
                ].map((item, idx) => (
                  <li className="daily-item" key={idx} >
                    <span className={`daily-dot ${item.color}`}></span>
                    <span className="daily-text">{item.time} - {item.text}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          
          {/* Video Testimonial Column */}
          <div className="content-col card" data-aos="zoom-in-left" data-aos-delay="300" data-aos-duration="1000">
            <div className="video-container">
              <div className="video-wrapper">
                <video
                  ref={videoRef}
                  className="video"
                  autoPlay
                  muted
                  playsInline
                  controls={false}
                >
                  <source src={videos[currentVideoIndex]} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
              <div className="video-info">
                <h5 className="video-title">How Parvam Changed My Routine</h5>
                <div className="testimonial">
                  <img
                    src="assets/images/Testimonial/testimonial_5.webp"
                    alt="Student"
                    className="testimonial-img"
                    width="48"
                  />
                  <div>
                    <h6 className="testimonial-name">Aadhya, Grade 7</h6>
                    <p className="testimonial-text">Improved focus by 60%</p>
                  </div>
                </div>
                <div className="testimonial mt-4 mb-0">
                  <img
                    src="assets/images/Testimonial/testimonial_2.webp"
                    alt="Student"
                    className="testimonial-img"
                    width="48"
                  />
                  <div>
                    <h6 className="testimonial-name">Aadhya, Grade 8</h6>
                    <p className="testimonial-text">Improved focus by 50%</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>




      {/* Yummy Learning */}
      <section className="py-5 bg-white">
        <div className="container py-5">
          <div className="text-center mb-5">
            <div className="icon-box-lg bg-success text-white rounded-circle p-3 d-inline-flex mb-4">
              <BookOpen size={30} />
            </div>
            <h3 className="h2 header-title">Yummy Learning</h3>
            <p className="lead text-muted max-w-800 mx-auto">
              90 days of delicious learning in English grammar and Mathematics with guaranteed results
            </p>
          </div>
          
          <div className="row g-4">
            <div className="col-md-4" data-aos="zoom-in-right" data-aos-delay="100" data-aos-durations="1000">
              <div className="program-card h-100 p-4 rounded-3 border-top border-3 border-success" >
                <Clock size={40} className="text-success mb-4" />
                <h3 className="h4 mb-3">90-Day Structure</h3>
                <ul className="list-unstyled mt-3">
                  <li className="d-flex mb-4">
                    <CheckCircle size={20} className="text-success me-2" />
                    <span>Days 1-30: Foundation Building</span>
                  </li>
                  <li className="d-flex mb-4" >
                    <CheckCircle size={20} className="text-success me-2" />
                    <span>Days 31-60: Skill Enhancement</span>
                  </li>
                  <li className="d-flex mt-2" >
                    <CheckCircle size={20} className="text-success me-2" />
                    <span>Days 61-90: Mastery & Assessment</span>
                  </li>
                </ul>
              </div>
            </div>
            
            <div className="col-md-4" data-aos="zoom-in-down" data-aos-delay="200" data-aos-durations="1000">
              <div className="program-card h-100 p-4 rounded-3 border-top border-3 border-warning">
                <Target size={40} className="text-warning mb-4" />
                <h3 className="h4 mb-3">Interactive Worksheets</h3>
                <div className="d-flex flex-column gap-3">
                  <div className="bg-warning bg-opacity-10 p-3 rounded">
                    <h4 className="h6 text-white mb-1">English Grammar</h4>
                    <p className="small text-muted mb-0">Fun exercises & quizzes</p>
                  </div>
                  <div className="bg-success bg-opacity-10 p-3 rounded">
                    <h4 className="h6 text-dark mb-1">Mathematics</h4>
                    <p className="small text-white mb-0">Problem-solving adventures</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="col-md-4"  data-aos="zoom-in-left" data-aos-delay="300" data-aos-durations="1000">
              <div className="program-card h-100 p-4 rounded-3 border-top border-3 border-info">
                <Star size={40} className="text-info mb-4" />
                <h3 className="h4 mb-5">Success Stories</h3>
                <div id="testimonialCarousel" className="carousel slide">
                  <div className="carousel-inner mt-3">
                    {testimonials.map((testimonial, index) => (
                      <div key={index} className={`carousel-item ${index === 0 ? 'active' : ''}`}>
                        <div className="bg-light p-3 rounded">
                          <p className="fst-italic mb-3">"{testimonial.quote}"</p>
                          <div className="d-flex align-items-center">
                            <img 
                              src={testimonial.img} 
                              alt={testimonial.name} 
                              className="rounded-circle me-3" 
                              width="40"
                            />
                            <div>
                              <h6 className="mb-0">{testimonial.name}</h6>
                              <small className="text-muted">{testimonial.grade}</small>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  <button className="carousel-control-prev " type="button" data-bs-target="#testimonialCarousel" data-bs-slide="prev">
                    <ChevronLeft size={24} />
                    <span className="visually-hidden">Previous</span>
                  </button>
                  <button className="carousel-control-next text-primary" type="button" data-bs-target="#testimonialCarousel" data-bs-slide="next">
                    <ChevronRight size={24} />
                    <span className="visually-hidden">Next</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Innoflip Classes */}
      <section>
            <div className="container">
            <div className="text-center mb-4">
            <div className="icon-box-lg bg-secondary text-white rounded-circle p-3 d-inline-flex mb-4">
              <Award size={30} />
            </div>
            <h3 className=" h2 display-6 fw-bold mb-2">Innoflip Classes</h3>
            <p className="lead text-muted max-w-800 mx-auto">
            </p>
          </div>
          <div className="row align-items-center ">

      {/* Left Column */}
      <div className="col-lg-6" data-aos='fade-in-left' data-aos-delay="400" data-aos-durations="1000">
            <div className="card shadow rounded overflow-hidden">
    {/* 16:9 video wrapper */}
    <div
      style={{
        position: "relative",
        paddingBottom: "56.25%", // 16:9
        height: 0,
        overflow: "hidden",
      }}
    >
      <video
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
        src="/assets/images/school3.mp4"
        muted
        autoPlay
        loop
        playsInline
        poster="/assets/images/Moments/moments_2.jpg"
      />
    </div>

    {/* Card content */}
    <div className="p-3">
      <h5 className="mb-2">Peer Teaching in Action</h5>
      <p className="small text-muted mb-0">
        Grade 9 student explains Physics confidently in front of peers.
      </p>
    </div>
  </div>
</div>


      {/* Right Column - Video */}

            <div className="col-lg-6 mb-5 mb-lg-0" data-aos='fade-in-right' data-aos-delay="400" data-aos-durations="1000">{/* Description */}
      <p className="text-muted mb-2">
        <strong className="text-primary">Innoflip</strong> is a peer-led learning experience where teaching is the most powerful form of learning — rooted in the <strong className="text-primary">Learning Pyramid</strong>.
      </p>

      {/* Pyramid Cards */}
      <div className="mb-4">
        {[
          { label: "Teaching Others", value: "90%", color: "#198754" },
          { label: "Practice by Doing", value: "75%", color: "#0dcaf0" },
          { label: "Discussion Groups", value: "50%", color: "#0d6efd" },
          { label: "Audio-Visual", value: "20%", color: "#ffc107" },
          { label: "Reading", value: "10%", color: "#6c757d" },
        ].map((item, idx) => (
          <div
            key={idx}
            className="d-flex justify-content-between align-items-center rounded-4 mb-3 shadow-sm"
            data-aos="zoom-in-right"
            data-aos-delay={`${idx *150}`}
            data-aos-durations="1000"
            style={{
              background: `${item.color}10`,
              borderLeft: `4px solid ${item.color}`,
              padding: "1rem 1.5rem",
              backdropFilter: "blur(4px)",
              WebkitBackdropFilter: "blur(4px)",
            }}
          >
            <span className="fw-semibold text-dark" style={{ fontSize: "1rem" }}>
              {item.label}
            </span>
            <span
              className="text-white fw-bold px-3 py-1"
              style={{
                background: `linear-gradient(90deg, ${item.color}, ${item.color}cc)`,
                borderRadius: "2rem",
                fontSize: "0.95rem",
              }}
            >
              {item.value}
            </span>
          </div>
        ))}
      </div>



</div>
              </div>
            </div>

          {/* Before vs After Cards */}
            <div className="row g-3 mx-5 p-3">
            {/* BEFORE CARD */}
            <div className="col-md-6">
              <div
                className="h-100 rounded-4 shadow-sm px-4 py-3 text-muted"
                style={{
                  background: `linear-gradient(135deg, #f8d7da, #fff)`,
                  borderLeft: '4px solid #dc3545',
                }}
              >
                <h6 className="text-danger fw-bold mb-3">Before</h6>
                <ul className="small mb-0 ps-3" style={{ lineHeight: '1.8' }}>
                  <li>Passive learning</li>
                  <li>30% retention</li>
                  <li>Low confidence</li>
                </ul>
              </div>
            </div>

            {/* AFTER CARD */}
            <div className="col-md-6">
              <div
                className="h-100 rounded-4 shadow-sm px-4 py-2 text-muted"
                style={{
                  background: `linear-gradient(135deg, #d1e7dd, #fff)`,
                  borderLeft: '4px solid #198754',
                }}
              >
                <h6 className="text-success fw-bold mb-3">After</h6>
                <ul className="small mb-0 ps-3" style={{ lineHeight: '1.8' }}>
                  <li>Active teaching</li>
                  <li>90% retention</li>
                  <li>High confidence</li>
                </ul>
              </div>
            </div>

          </div>

        </section>




      {/* Happy Beginning */}
      <section className="py-5 bg-">
  <div className="container py-5">
    {/* Header */}
    <div className="text-center mb-5">
      <div className="d-inline-flex justify-content-center align-items-center bg-danger bg-gradient text-white rounded-circle  shadow-lg mb-3" style={{ width: 60, height: 60 }}>
        <Smile size={28} />
      </div>
      <h2 className="h2  fw-bold display-6">Happy Beginning</h2>
      <p className="text-muted fs-5 mx-auto" style={{ maxWidth: "700px" }}>
        A 10-day joyful transition to reboot basics, school culture, and reignite student enthusiasm.
      </p>
    </div>

    {/* Carousel */}
    <div className="mb-5" data-aos="zoom-in-top" data-aos-delay="">
      <div id="happyCarousel" className="carousel slide" data-bs-ride="carousel" >
        <div className="carousel-inner rounded-4 shadow-sm overflow-hidden">
          {[
            { day: "Day 1", title: "Welcome Parade", img: "assets/images/banner1.jpg" },
            { day: "Day 2", title: "Classroom Connections", img: "assets/images/banner3.jpg" },
            { day: "Day 3", title: "Creative Expression", img: "assets/images/banner5.jpg" },
          ].map((item, index) => (
            <div key={index} className={`carousel-item ${index === 0 ? "active" : ""}`}>
<div className="relative overflow-hidden h-[400px] md:h-[250px]">
                <img
                  src={item.img}
                  className="w-100 h-100 object-fit-contain"
                  alt={item.title}
                />
                <div className="carousel-caption d-none d-sm-block d-md-block bg-dark bg-opacity-50 p-4 rounded-3">
                  <h5 className="text-white">{item.day}: {item.title}</h5>
                  <p className="text-light">Joyful start filled with connection and culture</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Controls */}
        <button className="carousel-control-prev" type="button" data-bs-target="#happyCarousel" data-bs-slide="prev">
          <span className="carousel-control-prev-icon"></span>
        </button>
        <button className="carousel-control-next" type="button" data-bs-target="#happyCarousel" data-bs-slide="next">
          <span className="carousel-control-next-icon"></span>
        </button>
      </div>
    </div>

    {/* 3 Pillars */}
    <div className="row g-4 d-none">
          <div className="col-lg-4">
            <div className="feature-card p-4 rounded-4 h-100">
              <div className="icon-container bg-pink-light text-pink rounded-circle p-3 d-inline-flex mb-4">
                <Heart size={28} />
              </div>
              <h3 className="h4 fw-bold mb-3">Culture Reboot</h3>
              <p className="text-muted mb-0">
                Reconnecting with school values and traditions through interactive workshops and team-building exercises.
              </p>
            </div>
          </div>
          
          <div className="col-lg-4">
            <div className="feature-card p-4 rounded-4 h-100">
              <div className="icon-container bg-primary-light text-primary rounded-circle p-3 d-inline-flex mb-4">
                <BookOpen size={28} />
              </div>
              <h3 className="h4 fw-bold mb-3">Basics Refresh</h3>
              <p className="text-muted mb-0">
                Strengthening fundamental concepts with engaging review sessions and hands-on learning.
              </p>
            </div>
          </div>
          
          <div className="col-lg-4">
            <div className="feature-card p-4 rounded-4 h-100">
              <div className="icon-container bg-warning-light text-warning rounded-circle p-3 d-inline-flex mb-4">
                <Zap size={28} />
              </div>
              <h3 className="h4 fw-bold mb-3">Enthusiasm Boost</h3>
              <p className="text-muted mb-0">
                Igniting passion for learning with exciting activities, guest speakers, and creative projects.
              </p>
            </div>
          </div>
        </div>
      </div>
      </section>





      {/* SCALE Life Skills */}
      <section className="py-1 bg-">
        <div className="container py-1">
          <div className="text-center mb-5">
            <div className="icon-box-lg bg-primary text-white rounded-circle p-3 d-inline-flex mb-4">
              <Target size={40} />
            </div>
            <h2 className=" h2 display-5 fw-bold mb-3">SCALE Life Skills</h2>
            <p className="lead text-muted max-w-800 mx-auto">
              Social, Communication, Agility, Leadership, and Emotional skills — taught as a structured curriculum
            </p>
          </div>
          
          <div className="row justify-content-center gap-4 mb-5">
            {[
              { letter: 'S', title: 'Social', icon: Users, color: 'primary' },
              { letter: 'C', title: 'Communication', icon: MessageCircle, color: 'info' },
              { letter: 'A', title: 'Agility', icon: Zap, color: 'warning' },
              { letter: 'L', title: 'Leadership', icon: Trophy, color: 'danger' },
              { letter: 'E', title: 'Emotional', icon: Heart, color: 'success' }
            ].map((skill, index) => (
              <div key={index} className="col-md-4 col-lg-2 col-6" data-aos="zoom-in-up"
              data-aos-delay={`${index * 100}`}
              data-aos-duration="1000">
                <div className={`skill-card bg-${skill.color} bg-opacity-10 text-center p-4 rounded-3 h-100`}>
                  <div className={`icon-box-md bg-${skill.color} text-white rounded-circle p-2 d-inline-flex mb-3`}>
                    <skill.icon size={24} />
                  </div>
                  <h3 className="display-6 fw-bold mb-2">{skill.letter}</h3>
                  <h4 className="h6 mb-0">{skill.title}</h4>
                </div>
              </div>
            ))}
          </div>
          
          <div className="row g-4">
  {/* Student Workshops Card */}
  <div className="col-lg-4" data-aos="zoom-in-right"
      data-aos-delay="300"
      data-aos-duration="1000">
    <div className="h-100 p-4 rounded-4 border-0 shadow-sm" style={{ 
      background: 'white',
      borderTop: '4px solid #4361ee'
    }}>
      <h3 className="h4 mb-4 fw-bold text-dark">Student Workshops</h3>
      <div className="d-flex flex-column gap-3">
        <div className="d-flex align-items-center p-3 rounded-3" style={{
          background: 'rgba(67, 97, 238, 0.05)',
          borderLeft: '3px solid #4361ee'
        }}>
          <img 
            src="https://img.icons8.com/ios/50/4361ee/group-foreground-selected.png" 
            alt="Team Building" 
            className="me-3"
            style={{ width: '24px', height: '24px' }}
          />
          <span className="fw-medium">Team Building Sessions</span>
        </div>
        
        <div className="d-flex align-items-center p-3 rounded-3" style={{
          background: 'rgba(23, 162, 184, 0.05)',
          borderLeft: '3px solid #17a2b8'
        }}>
          <img 
    src="https://icons.getbootstrap.com/assets/icons/people-fill.svg" 
    
    alt="Communication" 
            className="me-3"
            style={{ width: '24px', height: '24px', color: '#4361ee' }}
            />
          <span className="fw-medium">Communication Labs</span>
        </div>
        
        <div className="d-flex align-items-center p-3 rounded-3" style={{
          background: 'rgba(220, 53, 69, 0.05)',
          borderLeft: '3px solid #dc3545'
        }}>
          <img 
    src="https://icons.getbootstrap.com/assets/icons/award-fill.svg" 
    alt="Leadership" 
            className="me-3"
            style={{ width: '24px', height: '24px', color: '#dc3545' }}
            />
          <span className="fw-medium">Leadership Bootcamps</span>
        </div>
      </div>
    </div>
  </div>
  
  {/* Role Play Activities Card */}
  <div className="col-lg-4" data-aos="zoom-in-down"
      data-aos-delay="300"
      data-aos-duration="1000">
    <div className="h-100 p-4 rounded-4 border-0 shadow-sm" style={{ 
      background: 'white',
      borderTop: '4px solid #20c997'
    }}>
      <h3 className="h4 mb-4 fw-bold text-dark">Role Play Activities</h3>
      <div className="ratio ratio-16x9 mb-3 rounded-3 overflow-hidden">
        <img 
          src="https://images.unsplash.com/photo-1521791136064-7986c2920216?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1469&q=80" 
          alt="Mock Interview" 
          className="object-fit-cover"
        />
        <div className="position-absolute bottom-0 start-0 end-0 p-3" style={{
          background: 'linear-gradient(to top, rgba(0,0,0,0.7), transparent)'
        }}>
          <div className="d-flex align-items-center text-white">
            <img 
              src="https://img.icons8.com/ios/50/ffffff/play--v1.png" 
              alt="Play" 
              className="me-2"
              style={{ width: '20px', height: '20px' }}
            />
            <span className="small">Mock Interview Session</span>
          </div>
        </div>
      </div>
      <p className="small text-muted mb-0">Students practice real-world scenarios with industry professionals</p>
    </div>
  </div>
  
  {/* Public Speaking Card */}
  <div className="col-lg-4" data-aos="zoom-in-left"
      data-aos-delay="300"
      data-aos-duration="1000">
    <div className="h-100 p-4 rounded-4 border-0 shadow-sm" style={{ 
      background: 'white',
      borderTop: '4px solid #fd7e14'
    }}>
      <h3 className="h4 mb-4 fw-bold text-dark">Public Speaking</h3>
      <div className="ratio ratio-16x9 mb-3 rounded-3 overflow-hidden">
        <img 
          src="https://images.unsplash.com/photo-1505373877841-8d25f7d46678?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1412&q=80" 
          alt="Public Speaking" 
          className="object-fit-cover"
        />
        <div className="position-absolute bottom-0 start-0 end-0 p-3" style={{
          background: 'linear-gradient(to top, rgba(0,0,0,0.7), transparent)'
        }}>
          <div className="d-flex align-items-center text-white">
            <img 
              src="https://img.icons8.com/ios/50/ffffff/microphone--v1.png" 
              alt="Mic" 
              className="me-2"
              style={{ width: '20px', height: '20px' }}
            />
            <span className="small">Annual Speech Competition</span>
          </div>
        </div>
      </div>
      <p className="small text-muted mb-0">Building confidence through structured speaking exercises</p>
    </div>
  </div>
</div>
        </div>
      </section>

  {/* Section 1: Olympiad & Super 30 - Modern Card Design */}

      <div className="container py-5">
      <div className="text-center mb-5">
            <div className="icon-box-lg bg-primary text-white rounded-circle p-3 d-inline-flex mb-4">
              <ChevronLeft size={28} />
            </div>
            <h2 className="h2 display-5 fw-bold mb-3">  Olympiad & Super 30</h2>
            <p className="lead text-muted max-w-800 mx-auto">
              Social, Communication, Agility, Leadership, and Emotional skills — taught as a structured curriculum
            </p>
          </div>
         <section className="mb-5 p-4 p-md-5 card rounded-4 position-relative overflow-hidden">

{/* Decorative elements */}
<div className="position-absolute top-0 end-0 opacity-10">
</div>

<div className="row align-items-center position-relative" data-aos="zoom-in-right" data-aos-delay="300" data-aos-dutaions="800">
  <div className="col-lg-5 mb-4 mb-lg-0">
    <div className="pe-lg-4">
      <div className="d-flex align-items-center mb-3">
        <span className="badge bgcolor bg-opacity-10 text-white fs-6 fw-normal px-3 py-2 me-3">
          <i className="bi bi-trophy-fill  me-2"></i>Elite Program
        </span>
      </div>
      <h2 className="h3 fw-bold mb-3 text-dark">
        Olympiad & <span className="color">Super 30</span>
      </h2>
      <p className="fs-5 text-muted mb-4">
        Competitive exam foundation from Grade VI. Top 30 students receive elite training for NEET/JEE.
      </p>
      
      <div className="d-flex flex-column gap-3 mb-4">
      <div className="mb-4 p-3 rounded-3" style={{
        background: 'rgba(13, 110, 253, 0.03)',
        border: '1px dashed rgba(13, 110, 253, 0.3)'
      }}>
        <div className="achievement-scroller">
          <div className="scroller-content">
            <div className="d-flex align-items-center text-primary mb-2">
              <i className="bi bi-mortarboard-fill me-2"></i>
              <span>Many alumni are now studying MBBS and engineering in reputed institutions</span>
            </div>
            <div className="d-flex align-items-center text-success mb-2">
              <i className="bi bi-award-fill me-2"></i>
              <span>5 students secured top 100 ranks in JEE Advanced 2023</span>
            </div>
            <div className="d-flex align-items-center text-info">
              <i className="bi bi-hospital-fill me-2"></i>
              <span>12 students admitted to AIIMS and other top medical colleges</span>
            </div>
          </div>
        </div>
      </div>
        <div className="d-flex align-items-start">
          <div className="bg-primary bg-opacity-10 p-2 rounded-3 me-3">
            <i className="bi bi-check-circle-fill text-primary fs-5"></i>
          </div>
          <div>
            <h5 className="fw-bold mb-1">College Admissions</h5>
            <p className="text-muted small mb-0">Specialized coaching for NITs/IITs/MBBS admissions</p>
          </div>
        </div>
        <div className="d-flex align-items-start">
          <div className="bg-primary bg-opacity-10 p-2 rounded-3 me-3">
            <i className="bi bi-graph-up-arrow text-primary fs-5"></i>
          </div>
          <div>
            <h5 className="fw-bold mb-1">Performance Tracking</h5>
            <p className="text-muted small mb-0">Weekly mock tests with national ranking</p>
          </div>
        </div>
      </div>
      
      <button className="btn custom-hover px-4 py-2 rounded-pill">
        <i className="bi bi-arrow-right me-2"></i> Learn More
      </button>
    </div>
  </div>
  
  <div className="col-lg-7">
    <div className="row g-3">
      <div className="col-md-6">
        <div className="ratio ratio-16x9 rounded-4 overflow-hidden shadow-lg">
         <div className="ratio ratio-16x9 rounded-3 overflow-hidden shadow">
          <img 
            src="assets/images/banner1.jpg" 
            alt="Students in lab" 
            className="object-fit-cover"
          />
         </div>
          <div className="position-absolute bottom-0 start-0 end-0 p-3 bg-opacity-50 fw-bold text-white">
            <div className="d-flex justify-content-between align-items-center">
              <span>Classroom Training</span>
              <span className="badge bg-primary">98% Success</span>
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-6">
        <div className="ratio ratio-1x1 rounded-4 overflow-hidden shadow-lg mb-3">
          <img 
            src="/assets/images/index/Hero_img2.webp" 
            alt="Topper students" 
            className="object-fit-cover hover-zoom"
          />
          <div className="position-absolute top-0 end-0 m-3">
            <span className="badge bg-danger px-3 py-2 rounded-pill">
              <i className="bi bi-star-fill me-1"></i> Toppers 2024
            </span>
          </div>
        </div>  
        <div className="d-flex justify-content-between ">
          <span className="badge bg-success bg-opacity-10 text-white px-3 py-2 me-1">
            <i className="bi bi-check-circle me-1"></i> 50+ Selections
          </span>
          <span className="badge bg-info bg-opacity-10 text-white px-3 py-2">
            <i className="bi bi-award me-1"></i> 12 Olympiad Winners
          </span>
        </div>
      </div>
    </div>
    
    {/* Top Achievers Carousel */}
    <div className="mt-4">
      <h5 className=" fw-bold mb-3">Our Top Achievers</h5>
      <div className="achievers-carousel position-relative">
        <div className="scroller-container overflow-hidden">
          <div className="scroller-track d-flex">
            {[
              {name: "Rahul Sharma", rank: "JEE AIR 12", img: "https://randomuser.me/api/portraits/men/32.jpg"},
              {name: "Priya Patel", rank: "NEET AIR 8", img: "https://randomuser.me/api/portraits/women/44.jpg"},
              {name: "Amit Kumar", rank: "JEE AIR 24", img: "https://randomuser.me/api/portraits/men/65.jpg"},
              {name: "Neha Gupta", rank: "AIIMS MBBS", img: "https://randomuser.me/api/portraits/women/63.jpg"},
              {name: "Vikram Singh", rank: "JEE AIR 45", img: "https://randomuser.me/api/portraits/men/76.jpg"},
              {name: "Ananya Desai", rank: "NEET AIR 15", img: "https://randomuser.me/api/portraits/women/22.jpg"},
              {name: "Rohan Mehta", rank: "JEE AIR 33", img: "https://randomuser.me/api/portraits/men/11.jpg"},
              {name: "Divya Joshi", rank: "AIIMS MBBS", img: "https://randomuser.me/api/portraits/women/19.jpg"},
              {name: "Arjun Reddy", rank: "JEE AIR 28", img: "https://randomuser.me/api/portraits/men/42.jpg"},
              {name: "Isha Banerjee", rank: "NEET AIR 7", img: "https://randomuser.me/api/portraits/women/31.jpg"}
            ].map((student, index) => (
              <div key={index} className="achiever-item text-center mx-2">
                <div className="position-relative">
                  <img 
                    src={student.img} 
                    alt={student.name}
                    className="rounded-circle object-fit-cover border border-3 bdr"
                    width="80"
                    height="80"
                  />
                  <span className="position-absolute bottom-0 start-50 translate-middle-x badge bgcolor rounded-pill">
                    {student.rank}
                  </span>
                </div>
                <h6 className="mt-2 mb-0 fw-bold">{student.name}</h6>
                <small className="text-muted">Batch 2023</small>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
         </section>


         <div className="text-center mb-5">
            <div className="icon-box-lg bg-primary text-white rounded-circle p-3 d-inline-flex mb-4">
              <Lightbulb size={28} />
            </div>
            <h2 className="h2 display-5 fw-bold mb-3 ">ESCP & Protocol</h2>
            <p className="lead text-muted max-w-800 mx-auto">
              Social, Communication, Agility, Leadership, and Emotional skills — taught as a structured curriculum
            </p>
          </div>
          {/* Section 2: English Speaking Campus Protocol - Modern Card Design */}
          <section className="p-4 p-md-5 card rounded-4 position-relative overflow-hidden"
            >
            {/* Decorative elements */}
            <div className="position-absolute bottom-0 start-0 opacity-10">
              
            </div>
            <div className="row align-items-center position-relative"data-aos="zoom-in-left" data-aos-delay="300" data-aos-dutaions="800">
              <div className="col-lg-7 mb-4 mb-lg-0">
                <div className="row g-4">
                  <div className="col-md-4">
                    <div className="h-100 p-4 bg-white rounded-4 shadow-sm border-0 text-center hover-lift">
                    <div
                        className="icon-xl bg-danger bg-opacity-10 text-white rounded-circle mb-3 mx-auto"
                        // style={{ width: "60px", height: "60px" }}
                      >
                        <Mic size={28} />
                      </div>
                      <h4 className="h6 fw-bold mb-2">Star Communicator</h4>
                      <p className="small text-muted mb-0">
                        Weekly recognition badges for most fluent speakers
                      </p>
                      <div className="mt-3">
                        <span className="badge bg-danger bg-opacity-10 text-white small">
                          <i className="bi bi-gem me-1"></i> Gold Tier
                        </span>
                      </div>
                    </div>
                  </div>
                  
                  <div className="col-md-4">
                    <div className="h-100 p-4 bg-white rounded-4 shadow-sm border-0 text-center hover-lift">
                      <div className="icon-xl bg-warning bg-opacity-10 text-white rounded-circle mb-3 mx-auto">
                        <GraduationCap  size={28} />
                      </div>
                      <h4 className="h6 fw-bold mb-2">Voice Zones</h4>
                      <p className="small text-muted mb-0">
                        15+ designated speaking areas across campus
                      </p>
                      <div className="mt-3">
                        <span className="badge bg-warning bg-opacity-10 text-white small">
                          <i className="bi bi-volume-up me-1"></i> Active
                        </span>
                      </div>
                    </div>
                  </div>
                  
                  <div className="col-md-4">
                    <div className="h-100 p-4 bg-white rounded-4 shadow-sm border-0 text-center hover-lift">
                      <div className="icon-xl bg-success bg-opacity-10 text-white rounded-circle mb-3 mx-auto">
                      <Sparkles  size={28} />
                      </div>
                      <h4 className="h6 fw-bold mb-2">Language Masters</h4>
                      <p className="small text-muted mb-0">
                        Daily support from certified English experts
                      </p>
                      <div className="mt-3">
                        <span className="badge bg-success bg-opacity-10 text-white small">
                          <i className="bi bi-clock me-1"></i> 9AM-5PM
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="col-lg-5">
                <div className="ps-lg-4">
                  <div className="d-flex align-items-center mb-3">
                    <span className="badge bgcolor bg-opacity-10 text-white fs-6 fw-normal px-3 py-2 me-3">
                      <i className="bi bi-translate me-2"></i>Language Initiative
                    </span>
                  </div>
                  <h2 className="h3  fw-bold mb-3 text-dark">
                    <span className="color">ESCP</span> Protocol
                  </h2>
                  <p className="fs-5 text-muted mb-4">
                    A complete system ensuring 100% English immersion across campus
                  </p>
                  
                  <div className="d-flex flex-column gap-3 mb-4">
                    <div className="d-flex align-items-center">
                      <div className="bg-danger bg-opacity-10 p-2 rounded-3 me-3">
                        <i className="bi bi-people-fill text-danger fs-5"></i>
                      </div>
                      <div>
                        <h6 className=" mb-0">            A complete system ensuring 100% English immersion across campus
        </h6>
                      </div>
                    </div>
                    <div className="d-flex align-items-center">
                      <div className="bg-danger bg-opacity-10 p-2 rounded-3 me-3">
                        <i className="bi bi-calendar-check text-danger fs-5"></i>
                      </div>
                      <div>
                        <h6 className=" mb-0">            A complete system ensuring 100% English immersion across campus
        </h6>
                      </div>
                    </div>
                    <div className="d-flex align-items-center">
                      <div className="bg-danger bg-opacity-10 p-2 rounded-3 me-3">
                        <i className="bi bi-chat-square-text text-danger"></i>
                      </div>
                      <div>
                        <h6 className=" mb-0">            A complete system ensuring 100% English immersion across campus
        </h6>
                      </div>
                    </div>
                  </div>
                  
                  <button className="btn custom-hover px-4 py-2 rounded-pill">
                    <i className="bi bi-arrow-right me-2"></i> Program Details
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/*  Research and development  */}

          <section className="py-8 bg- position-relative">
          <div className="container">
            <div className="text-center mb-6 mt-3">
              <div className="icon-box-lg bg-primary text-white rounded-circle p-3 d-inline-flex mb-4">
                <Search size={28} />
              </div>
              <h2 className="h2 display-5 fw-bold mb-3">
                Research & Development
              </h2>
              <p className="lead text-muted max-w-800 mx-auto mb-3">
                Our expert faculty continuously analyzes performance, shapes curriculum, and mentors future leaders
              </p>
            </div>

            {/* Main Card - Large Rectangle */}
            <div className="card border-0 shadow-sm rounded-3 overflow-hidden"  data-aos="fade-in-left" data-aos-delay="200" data-aos-duration="800">
              <div className="row g-0">
                {/* Left Content Column */}
                <div className="col-lg-6 bg-white p-5">
                <div className="icon-box-lg bg-primary d-flex align-items-center text-white rounded-circle p-3 d-inline-flex mb-4">
                <Target size={28} />
              </div>
                  <h4 className=" fw-bold mb-4 me-2">
                      Dynamic Performance Tracking
                  </h4>

                  <div className="d-flex align-items-center mb-4 pb-3 border-bottom">
                  <div className="bg-primary bg-opacity-10  rounded-3 me-4 d-flex align-items-center justify-content-center" style={{ width: '15px', height: '10px' }}>
                    <i className="bi bi-clipboard2-pulse text-primary fs-4"></i>
                  </div>
                  <div>
                    <h4 className="h5 fw-bold mb-1 ">Real-time Analytics</h4>
                    <p className="text-muted mb-0">Live dashboards track student progress metrics</p>
                  </div>
                </div>

                  <div className="d-flex align-items-center mb-4 pb-3 border-bottom">
                  <div className="bg-primary bg-opacity-10  rounded-3 me-4 d-flex align-items-center justify-content-center" style={{ width: '15px', height: '10px' }}>
                      <i className="bi bi-robot text-primary fs-4"></i>
                    </div>
                    <div>
                      <h4 className="h5 fw-bold mb-1">AI-Powered Insights</h4>
                      <p className="text-muted mb-0">Machine learning identifies learning patterns</p>
                    </div>
                  </div>

                  <div className="d-flex align-items-center mb-4 pb-3 border-bottom">
                  <div className="bg-primary bg-opacity-10  rounded-3 me-4 d-flex align-items-center justify-content-center" style={{ width: '15px', height: '10px' }}>
                      <i className="bi bi-kanban-fill text-primary fs-4"></i>
                    </div>
                    <div>
                      <h4 className=" h5 fw-bold mb-1">Curriculum Kanban</h4>
                      <p className="text-muted mb-0">Agile development of teaching materials</p>
                    </div>
                  </div>
                  
                  <button className=" float-end custom-hover  px-4 py-3 rounded-pill">
                    <i className="bi bi-journal-bookmark-fill me-2"></i>
                    View Annual Report
                  </button>
                </div>
                
                {/* Right Image Column */}
                <div className="col-lg-6 position-relative">
                  <div className="h-100 w-100">
                    <img 
                      src="https://images.unsplash.com/photo-1573164713988-8665fc963095?ixlib=rb-4.0.3&auto=format&fit=crop&w=1469&q=80" 
                      alt="Team analyzing data" 
                      className="img-fluid w-100 h-100"
                      style={{ objectFit: 'cover', minHeight: '100%' }}
                    />
                    <div className="position-absolute bottom-0 start-0 end-0 p-4 bg-dark bg-opacity-75 text-white">
                      <div className="row">
                        <div className="col-md-4 text-center py-2 border-end">
                          <h3 className="fw-bold mb-0">12+</h3>
                          <p className="small mb-0">Syllabus Versions</p>
                        </div>
                        <div className="col-md-4 text-center py-2 border-end">
                          <h3 className="fw-bold mb-0">94%</h3>
                          <p className="small mb-0">Success Rate</p>
                        </div>
                        <div className="col-md-4 text-center py-2">
                          <h3 className="fw-bold mb-0">48</h3>
                          <p className="small mb-0">Faculty Trained</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="mt-6 pt-5">
              <h3 className="h2 fw-bold display-5 mb-5 text-center d-flex align-items-center justify-content-center">
                Meet Our Core Team
              </h3>

              <div className="row g-4 justify-content-center">
              {[1, 2, 3, 4].map((_, i) => (
              <div key={i} className="col-md-6 col-lg-3" data-aos="zoom-in-down" data-aos-delay={`${i * 150 }`} data-aos-duration="800">
              <div className="team-card bg-white rounded-4 p-4 shadow-sm h-100 text-center">
                <div className="avatar-xl mx-auto mb-4 position-relative">
                  <img
                    src={teacherImages[i]}
                    alt={`Teacher ${i + 1}`}
                    className="rounded-circle mb-2"
                    style={{ width: "100px", height: "100px", objectFit: "cover" }}
                  />
                  {/* <span className="position-absolute bottom-0 end-0 bg-primary text-white rounded-circle p-2 border border-3 border-white">
                    <i className={`bi ${teacherIcons[i]}`}></i>
                  </span> */}
                </div>
                <h5 className="mb-1 fw-bold">Dr. {teacherNames[i]}</h5>
                <p className="text-muted small mb-3">{teacherRoles[i]}</p>
                {/* <div className="d-flex justify-content-center gap-3">
                  <a href="#" className="text-primary"><i className="bi bi-linkedin fs-5"></i></a>
                  <a href="#" className="text-primary"><i className="bi bi-envelope-fill fs-5"></i></a>
                  <a href="#" className="text-primary"><i className="bi bi-file-text-fill fs-5"></i></a>
                </div> */}
              </div>
            </div>
          ))}
        </div>
            </div>
        </div>
        </div>
  );
};

export default Programs;